const changeImgSrc = (size) => {
  const imagesChange = document.querySelectorAll('.js-images-change')
  const srcImage = imagesChange[0].style.backgroundImage.split('')
  const indexPlace = srcImage.indexOf('.')

  srcImage.splice(indexPlace, 0, size)
  imagesChange.forEach(item => {
    item.style.backgroundImage = srcImage.join('')
  })
}

if (window.innerWidth >= 1921 && $('.js-images-change').length) {
  changeImgSrc('@2x')
}
// if (window.innerWidth <= 659) {
//   changeImgSrc('_mob')
// }
